export const teamMembers = [
    {
        id : 1,
        name : 'Thabang Mashiloane',
        title: 'CEO, Hash Protocol',
        text: 'Studied Computer Scienc & AI, Co-founder @Hashbridge, ',
        image: 'team/pfp.png',
        socials: {
            twitter : 'https://twitter.com/cryptosciencist',
            discord : '',
            github : 'https://github.com/maexx393',
            email : '',
            linkedin : 'https://www.linkedin.com/in/thabangmashiloane/',
        }
    },
    {
        id : 2,
        name : 'Tim Siwula',
        title: 'CTO, Hash Protocol',
        text: 'Former senior engineer at Consensys',
        image: 'team/pfp.png',
        socials: {
            twitter : 'https://twitter.com/',
            discord : '',
            github : 'https://github.com/timxor/timxor.github.io',
            email : '',
            linkedin : 'https://www.linkedin.com/in/',
        }
    },
]
